import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorPicture = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="m8.552 9.655 10.919 10.876 1.058-1.062-6.483-6.458 1.345-1.353a2.25 2.25 0 0 1 3.183-.01l2.897 2.884 1.058-1.064-2.897-2.882a3.75 3.75 0 0 0-5.305.015l-1.343 1.351-3.373-3.36a3.75 3.75 0 0 0-5.312.02l-2.832 2.86 1.066 1.056 2.832-2.862a2.25 2.25 0 0 1 3.187-.01Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M1.25 7A3.75 3.75 0 0 1 5 3.25h14A3.75 3.75 0 0 1 22.75 7v10A3.75 3.75 0 0 1 19 20.75H5A3.75 3.75 0 0 1 1.25 17V7ZM5 4.75A2.25 2.25 0 0 0 2.75 7v10A2.25 2.25 0 0 0 5 19.25h14A2.25 2.25 0 0 0 21.25 17V7A2.25 2.25 0 0 0 19 4.75H5Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorPicture;
